<div class="sidebar-panel">
  <div
    id="scroll-area"
    [perfectScrollbar]
    class="navigation-hold flex flex-col"
  >
    <div class="sidebar-hold">

      
      <div class="branding text-center">
        <span class="text-center">HANUMAN DMS </span>
      </div>
      <div
        class="icon-menu-list flex flex-row justify-center"
        style="padding-bottom: 10px"
      >
        <a
          class="text-muted"
          mat-icon-button
          mat-xs-button
          matTooltip="Dashboard"
          routerLink="/dashboard/default"
          *ngIf="permissionService.can('dashboard:view')"
        >
          <mat-icon class="text-[18px] !flex justify-center items-center"
            >home</mat-icon
          >
        </a>
        <a
          class="text-muted"
          mat-icon-button
          mat-xs-button
          matTooltip="New Order"
          routerLink="/sales/order/new"
          *ngIf="permissionService.can('sale_order:view')"
        >
          <mat-icon class="text-[18px] !flex justify-center items-center"
            >shopping_cart</mat-icon
          >
        </a>
        <a
          class="text-muted"
          mat-icon-button
          mat-xs-button
          matTooltip="Gratis Claim"
          routerLink="/gratis/claim-trade"
          *ngIf="permissionService.can('gratis_claim:view')"
        >
          <mat-icon class="text-[18px] !flex justify-center items-center"
            >flip_to_front</mat-icon
          >
        </a>
        <a
          class="text-muted"
          mat-icon-button
          mat-xs-button
          matTooltip="Delivery Order"
          routerLink="/sales/delivery-order"
          *ngIf="permissionService.can('delivery:view')"
        >
          <mat-icon class="text-[18px] !flex justify-center items-center">
            local_shipping
          </mat-icon>
        </a>
      </div>
      <mat-divider class="w-[240px]"></mat-divider><br />
      <!-- Navigation -->
      <app-sidenav
        [items]="menuItems"
        [hasIconMenu]="hasIconTypeMenuItem"
        [iconMenuTitle]="iconTypeMenuTitle"
      ></app-sidenav>
    </div>
  </div>
</div>
